import AppBar from "../../components/AppBar";
import searchIcon from "../../assets/svg/search-icon.svg";
import Nav from "../../assets/svg/icon1.svg";
import chatIcon from "../../assets/png/chat-icon.png";
import { useNavigate, useLocation } from "react-router-dom";
import { useEffect, useState, useRef } from "react";
import { apiRequest } from "../../services/api_services/ApiServices";
import { toast } from "react-toastify";
import chat_icon from "../../assets/svg/Cha1.svg";

const UserView = () => {
  const { state } = useLocation();
  const userName = state?.userName;
  const userId = state?.userId;
  const navigate = useNavigate();
  const [conversationList, setConversationList] = useState([]);
  const [convoDetails, setConvoDetails] = useState({});
  const hasFetchedRef = useRef(false);
  const endRef = useRef(null);

  useEffect(() => {
    if (hasFetchedRef.current) return;

    hasFetchedRef.current = true;
    fetchConversationList();
  });

  const fetchConversationList = async () => {
    try {
      const response = await apiRequest({
        method: "get",
        url: "userconvo_list",
        params: {
          user_id: userId,
        },
      });
      if (response.statuscode === 400) {
      } else {
        if (response?.success === true) {
          setConversationList(response?.convos ?? []);
          console.log(response?.convos);
        } else {
          toast.error(
            response?.message || "Failed to fetch conversations list"
          );
        }
      }
    } catch (error) {
      toast.error("Application list error");
    }
  };

  const conversationViewDetails = async (convoId) => {
    try {
      const response = await apiRequest({
        method: "get",
        url: `userconvo_view/${convoId}`,
      });

      // apiRequest already returns response.data
      if (!response?.success) {
        toast.error(response?.message || "Failed to fetch conversations");
        return;
      }

      setConvoDetails(response.convo || {});
      console.log("Convo:", response.convo);
      console.log("Title:", response.convo?.title);
    } catch (error) {
      console.error("Conversation fetch error:", error);
      toast.error("Failed to load conversation");
    }
  };

  return (
    <div className="min-h-screen flex flex-col bg-[#F8F9FB]">
      <AppBar
        title="User Chats"
        onClick={() => {
          navigate("/admin_setting", { state: { selectedTab: "Users" } });
        }}
      />

      <div className="flex flex-1 overflow-hidden">
        <aside className="bg-white border-r px-4 py-4 flex flex-col">
          <div className="flex items-center justify-between mb-3">
            <h3 className="font-semibold text-base font-omny ">{userName}</h3>
          </div>

          {/* <div className="flex items-center gap-2 mb-4">
            <select className="w-full border rounded-full fill-[#F2F2F2] px-3 py-2.5 text-sm text-[#004BA8] font-omny font-medium border-transparent">
              <option>All apps</option>
            </select>
            <button className="border rounded-full px-1.5 py-1 h-8 w-10 items-center justify-center">
              <img src={searchIcon} alt="Search"></img>
            </button>
          </div> */}

          {conversationList.length > 0 ? (
            <div className="flex flex-col gap-2">
              {conversationList.map((convo, index) => (
                <div
                  key={convo.id ?? index}
                  className="
          w-[240px]
          flex items-center gap-2
          rounded-xl
          bg-gray-100
          px-3 py-2
          text-sm text-black
          cursor-pointer
          transition
          hover:bg-gray-300
          active:bg-gray-200
        "
                  onClick={() => {
                    conversationViewDetails(convo.id);
                  }}
                >
                  <img
                    src={chat_icon}
                    alt="Chat"
                    className="w-6 h-6 rounded-lg"
                  />

                  <span className="truncate font-medium font-omny">
                    {convo.title}
                  </span>
                </div>
              ))}
            </div>
          ) : (
            <p className="text-base text-gray-500 px-4 font-omny justify-center items-center h-full flex flex-col">
              No conversations found
            </p>
          )}
        </aside>

        <main className="w-full flex flex-col px-6 py-6 overflow-y-auto bg-white m-4 rounded-sm">
          <div className="max-h-[70vh] overflow-y-auto space-y-4">
            {Object.keys(convoDetails).length === 0 ? (
              <div className="flex justify-start mt-6">
                <div className="max-w-[70%] px-4 py-2 rounded-lg bg-gray-100 text-gray-800 text-sm font-omny">
                  Hello! There is no chat available for this user.
                </div>
              </div>
            ) : (
              <div key={convoDetails.id} className="w-full space-y-2">
                {/* <div className="text-center text-xs text-gray-400">
                  {chat.date}
                </div> */}

                {convoDetails.title && (
                  <div className="flex justify-end">
                    <div className="max-w-[70%] px-4 py-2 rounded-lg bg-blue-100 text-gray-800 text-sm font-omny">
                      {convoDetails.title}
                    </div>
                  </div>
                )}

                {/* {chat.answer && (
                  <div className="flex justify-start">
                    <div className="max-w-[70%] px-4 py-2 rounded-lg bg-gray-100 text-gray-800 text-sm">
                      {chat.answer}
                    </div>
                  </div>
                )} */}
              </div>
            )}

            <div ref={endRef} />
          </div>
        </main>
      </div>
    </div>
  );
};

export default UserView;
